import { createFileRoute } from '@tanstack/react-router'
import { ConversationsPage } from '../../components/conversations/ConversationsPage'

// The resident request ledger (spec 2026-09-02-05). A tab beside Pilotage, not
// a separate app: a conversation is a request, and reading it next to the
// tickets it produced is the point.
export const Route = createFileRoute('/$org/conversations')({
    component: Conversations,
    validateSearch: (search: Record<string, unknown>) => ({
        status: search.status ? String(search.status) : undefined,
        channel: search.channel ? String(search.channel) : undefined,
        resolution: search.resolution ? String(search.resolution) : undefined,
        // An asset subtree, through the scope columns.
        asset: search.asset ? String(search.asset) : undefined,
        unattached: search.unattached ? String(search.unattached) : undefined,
        // The sidebar badge's list (spec 2026-10-27-23). Optional, so the
        // links that predate it need not name it.
        ...(search.unread === true || search.unread === 'true' ? { unread: 'true' as const } : {}),
        // The caller's own unsent drafts, composing with `status` exactly
        // like `unattached` (spec 2026-09-23-03).
        draft: search.draft ? String(search.draft) : undefined,
        q: search.q ? String(search.q) : undefined,
        // The shareable address of a thread. `selected` is the pre-2026-09-09
        // name, kept read-only for one release so a bookmark or a link
        // pasted in a chat history still opens — ConversationsPage redirects
        // it to `conversation` on load and never writes it itself.
        conversation: search.conversation ? String(search.conversation) : undefined,
        selected: search.selected ? String(search.selected) : undefined,
        // The closed ticket a manager came here to answer for (spec
        // 2026-09-16-09): the panel seeds the composer with its closing
        // message once, then drops the parameter from the URL so a reload
        // does not re-seed over what is being typed.
        reply_for_issue: search.reply_for_issue ? String(search.reply_for_issue) : undefined,
        // A message inside the open thread. Only meaningful alongside
        // `conversation`.
        message: search.message ? String(search.message) : undefined,
    }),
})

function Conversations() {
    return <ConversationsPage />
}
